var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1921_5822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.639 15.9999C17.639 15.7879 17.569 15.5929 17.4535 15.4321L21.0247 9.4101C21.1402 9.21341 21.072 8.96371 20.8725 8.84912C20.673 8.73623 20.4158 8.80294 20.2986 8.99791L16.7291 15.0199C16.6976 15.0165 16.6661 15.0148 16.6329 15.0148C16.4159 15.0148 16.2147 15.0832 16.0502 15.1978L11.7931 12.7948C11.5919 12.6819 11.3364 12.7486 11.2192 12.9453C11.1037 13.142 11.172 13.3917 11.3732 13.5063L15.6285 15.9076C15.625 15.9384 15.6233 15.9692 15.6233 15.9999C15.6233 16.5421 16.0747 16.9851 16.6311 16.9851C17.1876 16.9851 17.639 16.5438 17.639 15.9999Z",
    fill: "#0D4066",
    stroke: "#0D4066",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6314 0C16.4004 0 16.2114 0.183004 16.2114 0.410476V3.36419C16.2114 3.58995 16.3986 3.77467 16.6314 3.77467C23.5271 3.77467 29.1385 9.25965 29.1385 16C29.1385 22.7404 23.5271 28.2253 16.6314 28.2253C16.4004 28.2253 16.2114 28.4083 16.2114 28.6358V31.5895C16.2114 31.8153 16.3986 32 16.6314 32C25.6565 32 33.0001 24.8218 33.0001 16C33.0001 7.17819 25.6565 0 16.6314 0Z",
    fill: "#3D6EDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8798 3.90125C12.9306 4.08425 13.1003 4.20568 13.2858 4.20568C13.3225 4.20568 13.3592 4.20055 13.3942 4.192C13.6182 4.13385 13.7512 3.90809 13.6917 3.68917L12.9096 0.836363C12.8501 0.617442 12.6191 0.487459 12.3951 0.545609C12.1712 0.60376 12.0382 0.829522 12.0977 1.04844L12.8798 3.90125Z",
    fill: "#0D4066",
    stroke: "#0D4066",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01986 2.29351C8.90438 2.09682 8.64717 2.03012 8.44595 2.143C8.24473 2.25588 8.17649 2.5073 8.29197 2.70398L9.80374 5.26261C9.88073 5.39431 10.0225 5.46785 10.1677 5.46785C10.2394 5.46785 10.3112 5.45075 10.3777 5.41312C10.5789 5.30024 10.6471 5.04883 10.5316 4.85214L9.01986 2.29351Z",
    fill: "#0D4066",
    stroke: "#0D4066",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65011 4.68625C5.48564 4.52548 5.22143 4.52548 5.05695 4.68625C4.89247 4.84702 4.89247 5.10699 5.05695 5.26605L7.19338 7.35434C7.27561 7.43473 7.38235 7.47407 7.49083 7.47407C7.59931 7.47407 7.70605 7.43473 7.78829 7.35434C7.95276 7.19357 7.95276 6.93361 7.78829 6.77455L5.65186 4.68625H5.65011Z",
    fill: "#0D4066",
    stroke: "#0D4066",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.60903 8.56018L5.22664 10.0379C5.29313 10.0755 5.36486 10.0926 5.4366 10.0926C5.58183 10.0926 5.72356 10.0191 5.80055 9.88738C5.91603 9.6907 5.84779 9.44099 5.64657 9.3264L3.02897 7.84869C2.8295 7.73581 2.57229 7.80251 2.45506 7.9992C2.33957 8.19588 2.40781 8.44559 2.60903 8.56018Z",
    fill: "#0D4066",
    stroke: "#0D4066",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.11633 12.3604L4.03489 13.1249C4.07164 13.1352 4.10838 13.1386 4.14337 13.1386C4.32885 13.1386 4.49857 13.0172 4.54931 12.8342C4.6088 12.6153 4.47582 12.3895 4.25186 12.3314L1.3333 11.5668C1.11108 11.5087 0.880119 11.6387 0.818878 11.8576C0.759387 12.0765 0.892367 12.3023 1.11633 12.3604Z",
    fill: "#0D4066",
    stroke: "#0D4066",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12436 16C4.12436 15.7725 3.93714 15.5895 3.70442 15.5895H0.682632C0.451667 15.5895 0.262695 15.7725 0.262695 16C0.262695 16.2274 0.449917 16.4104 0.682632 16.4104H3.70442C3.93539 16.4104 4.12436 16.2274 4.12436 16Z",
    fill: "#0D4066",
    stroke: "#0D4066",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54931 19.1641C4.48982 18.9452 4.25886 18.8152 4.03489 18.8734L1.11633 19.6379C0.892367 19.696 0.759387 19.9218 0.818878 20.1407C0.86962 20.3237 1.03934 20.4451 1.22482 20.4451C1.26156 20.4451 1.29831 20.44 1.3333 20.4315L4.25186 19.667C4.47582 19.6088 4.6088 19.383 4.54931 19.1641Z",
    fill: "#0D4066",
    stroke: "#0D4066",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7986 22.1127C5.68311 21.916 5.4259 21.8493 5.22468 21.9622L2.60708 23.4399C2.40586 23.5528 2.33762 23.8042 2.4531 24.0009C2.53009 24.1326 2.67182 24.2061 2.81705 24.2061C2.88879 24.2061 2.96053 24.189 3.02701 24.1514L5.64462 22.6737C5.84584 22.5608 5.91408 22.3094 5.7986 22.1127Z",
    fill: "#0D4066",
    stroke: "#0D4066",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19338 24.6439L5.05695 26.7322C4.89247 26.893 4.89247 27.1529 5.05695 27.312C5.13919 27.3924 5.24592 27.4317 5.35441 27.4317C5.46289 27.4317 5.56962 27.3924 5.65186 27.312L7.78829 25.2237C7.95276 25.0629 7.95276 24.803 7.78829 24.6439C7.62381 24.4831 7.3596 24.4831 7.19513 24.6439H7.19338Z",
    fill: "#0D4066",
    stroke: "#0D4066",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3777 26.5868C10.1764 26.474 9.92097 26.5407 9.80374 26.7374L8.29197 29.296C8.17649 29.4927 8.24473 29.7424 8.44595 29.857C8.51244 29.8946 8.58418 29.9117 8.65591 29.9117C8.80114 29.9117 8.94287 29.8382 9.01986 29.7065L10.5316 27.1478C10.6471 26.9511 10.5789 26.7014 10.3777 26.5868Z",
    fill: "#0D4066",
    stroke: "#0D4066",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3942 27.8081C13.1703 27.7499 12.9411 27.8799 12.8798 28.0988L12.0977 30.9516C12.0382 31.1705 12.1712 31.3963 12.3951 31.4545C12.4319 31.4647 12.4686 31.4681 12.5036 31.4681C12.6891 31.4681 12.8588 31.3467 12.9096 31.1637L13.6917 28.3109C13.7512 28.092 13.6182 27.8679 13.3942 27.8081Z",
    fill: "#0D4066",
    stroke: "#0D4066",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1921_5822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.3e3084b82f9b5cfafb0934b92c8d2258.svg";
export { ForwardRef as ReactComponent };